// NPM Pacakges
import React, { Fragment, useEffect, memo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import classNames from 'classnames';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Container, Modal } from 'reactstrap';

//Elements - start with Capital
import Login from '../screens/Login';
import { Navigation, Header } from '../components';
import { UserList, UserForm } from '../screens/User';
import { LicenseForm, LicenseList } from '../screens/License';
import { FacilityForm } from '../screens/Facility';
import { EquipmentForm, EquipmentList } from '../screens/Equipment';
import { ModelForm, ModelList } from '../screens/EquipmentModel';
import HistoryList from '../screens/History';
import { PreferenceForm, PreferenceList } from '../screens/Preference';
import Report from '../screens/Report';
import {
  TrackingSystemForm,
  TrackingSystemList,
  TrackingSystemContactForm,
  TrackingSystemContactList
} from '../screens/TrackingSystem';
import {
  CATSoftwareVersionList,
  CATSoftwareVersionForm
} from '../screens/CATSoftwareVersion';

//redux actions
import { login, applicationSetting } from '../redux/actions';
import utility from '../utility';

//Helper
import consts from '../consts';

const ApplicationRouteHandler = memo(({ component: Component, ...rest }) => (
  <Route {...rest} render={routeProps => <Component {...routeProps} />} />
));

const ModelHandler = memo(({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={routeProps => (
      <Modal backdrop={false} isOpen={true} size="xl" fade={false}>
        <Component {...routeProps} />
      </Modal>
    )}
  />
));

const ApplicationRoute = memo(props => {
  const dispatch = useDispatch();
  const data = useSelector(state => {
    return { settingData: state.settingData, loginData: state.loginData };
  }, shallowEqual);

  useEffect(() => {
    if (data.loginData.data && !data.loginData.data.hasOwnProperty('success')) {
      dispatch(login(null, { apiMethod: 'GET' }));
    }
  }, []);

  useEffect(() => {
    const loginData = data.loginData.data || {};
    if (loginData.success && loginData.userDetail) {
      let isDark = loginData.userDetail.PreferredTheme === 'dark';
      utility.applicationBody(isDark);
      dispatch(applicationSetting({ isDark: isDark }));
    }
  }, [data.loginData]);
  const { userDetail = {} } = (data && data.loginData.data) || {};
  let shouldCreateRoute = true,
    isViewer = false;
  if (userDetail && userDetail.UserRole) {
    shouldCreateRoute = consts.UserRoleId.SuperAdmin.includes(
      userDetail.UserRole
    );
    isViewer = consts.UserRoleId.Viewer.includes(userDetail.UserRole);
  }
  return (
    <Fragment>
      <Navigation />
      <Container
        fluid
        className={classNames('content', {
          'is-open': data.settingData.navOpen
        })}
      >
        <Header />
        <div className="main">
          <Switch
            location={{
              ...props.location,
              pathname: props.location.skip
                ? props.location.pathname
                : '/' + props.location.pathname.split('/').splice(1)[0]
            }}
          >
            {shouldCreateRoute && (
              <Route exact path="/usermanagement" component={UserList} />
            )}
            {shouldCreateRoute && (
              <Route
                exact
                path="/catsoftwareversion"
                component={CATSoftwareVersionList}
              />
            )}
            <Route exact path="/managelicense" component={LicenseList} />
            <Route exact path="/site" component={LicenseList} />
            {!isViewer && (
              <Route
                exact
                path="/equipment"
                render={props => <EquipmentList {...props} />}
              />
            )}
            <Route exact path="/licenseDetail" component={null} />
            <Route exact path="/history/:id" component={HistoryList} />
            <Route exact path="/reports" component={Report} />
            <Route exact path="/managePreference" component={PreferenceList} />
            {!isViewer && (
              <Route exact path="/modelList" component={ModelList} />
            )}
            {!isViewer && (
              <Route
                exact
                path="/trackingSystem"
                component={TrackingSystemList}
              />
            )}
            {!isViewer && (
              <Route
                exact
                path="/trackingSystemContact"
                component={TrackingSystemContactList}
              />
            )}
            <Route path="*" render={() => <Redirect to="/" />} />
          </Switch>
          <Route path="/licenseDetail/:id" component={LicenseForm} />

          {shouldCreateRoute && (
            <>
              <ModelHandler
                exact
                path="/usermanagement/:id"
                component={UserForm}
              />
            </>
          )}
          {!isViewer && (
            <ModelHandler exact path="/site/:id" component={FacilityForm} />
          )}
          {!isViewer && (
            <ModelHandler
              exact
              path="/equipment/:id/:licenseId"
              component={EquipmentForm}
            />
          )}
          <ModelHandler
            exact
            path="/managePreference/:id"
            component={PreferenceForm}
          />
          {!isViewer && (
            <ModelHandler exact path="/modelList/:id" component={ModelForm} />
          )}
          {!isViewer && (
            <ModelHandler
              exact
              path="/trackingSystem/:id"
              component={TrackingSystemForm}
            />
          )}
          {!isViewer && (
            <ModelHandler
              exact
              path="/trackingSystemContact/:id/"
              component={TrackingSystemContactForm}
            />
          )}
          {shouldCreateRoute && (
            <ModelHandler
              exact
              path="/catsoftwareversion/:id/"
              component={CATSoftwareVersionForm}
            />
          )}
        </div>
      </Container>
    </Fragment>
  );
});

export default memo(props => {
  return (
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path="/login" component={Login} />
      <ApplicationRouteHandler path="/" component={ApplicationRoute} />
    </Switch>
  );
});
